import React from "react";


export function TabItem({ dataQa, tab, currentTab, onClick, children }) {
    return <span data-qa={dataQa} className={currentTab === tab ? "active" : ""} onClick={() => onClick(tab)}>{children}</span>;
}